import { Component } from '@angular/core';

import { SedsButtonTypeOptions } from '../../seds-buttons/enums/seds-button-type-options.enum';
import { SedsSquareButtonAbstractComponent } from '../../seds-buttons/seds-square-button-abstract';

@Component({
    selector: 'seds-basic-button',
    templateUrl: './seds-basic-button.component.html',
    styleUrls: ['./seds-basic-button.component.scss'],
    standalone: false
})
export class SedsBasicButtonComponent extends SedsSquareButtonAbstractComponent {
  colors: any = {
    primary: 'primary-basic-button',
    accent: 'accent-basic-button',
    secondary: 'secondary-basic-button',
    tertiary: 'tertiary-basic-button',
    success: 'success-basic-button',
    error: 'error-basic-button',
  };

  override type = SedsButtonTypeOptions.BASIC;
}
